import { Component, Input, ElementRef } from '@angular/core';

@Component({
    selector: 'al-tips-alerts',
    template: `
       <div [ngClass]="{'al-tip': tipType === 'tip', 'al-alert': tipType === 'action'}">
        <al-badges [attr.title]="badgeTitle ? badgeTitle : null" [type]="tipType" [size]="'small'">{{tipText}}</al-badges>
        <div>

            <ng-container [ngSwitch]="tipSize">
                <h4 *ngSwitchCase="'large'" [ngClass]="{'brand-alert-1': tipType === 'action', 'brand-clr2-c': tipType === 'tip'}">
                    <ng-container *ngTemplateOutlet="tipTitleContent"></ng-container>
                </h4>

                <h5 *ngSwitchCase="'medium'" [ngClass]="{'brand-alert-1': tipType === 'action', 'brand-clr2-c': tipType === 'tip'}">
                    <ng-container *ngTemplateOutlet="tipTitleContent"></ng-container>
                </h5>

                <h6 *ngSwitchCase="'small'" [ngClass]="{'brand-alert-1': tipType === 'action', 'brand-clr2-c': tipType === 'tip'}">
                    <ng-container *ngTemplateOutlet="tipTitleContent"></ng-container>
                </h6>
            </ng-container>

            <div class="al-tip-contextOverlay al-arrow-on brand-tip1-a" [class.hidden]="moreLess" role="dialog" aria-hidden="false" *ngIf="showHide">
            <p>{{tipMessage}}</p>
            </div>

            <div class="al-tips-details" role="dialog" *ngIf="(moreLess && moreLessTextDispaly === lessText) || (!moreLess && !linkText)">
                <p *ngIf="tipMessage && tipSize === 'small'; else tipContent"><small>{{tipMessage}}</small></p>
                <p *ngIf="tipMessage && tipSize !== 'small'; else tipContent">{{tipMessage}}</p>
            </div>

            <ng-template #tipContent>
                <ng-content></ng-content>
            </ng-template>

            <ng-template #tipTitleContent>
                <strong *ngIf="displayText">{{displayText}}</strong>
                <ng-container *ngIf="!displayText">
                    <ng-content select="[customDisplayText]"></ng-content>
                </ng-container>
                <a *ngIf="!moreLess && linkText" aria-haspopup="true" (click)="toggleTipsAlerts()" class="al-tooltip al-font-s al-nobold" href="javascript:void(0);">{{linkText}}</a>
                <a (click)="toggleTipsAlerts()" aria-haspopup="true" href="javascript:void(0);" *ngIf="moreLess && tipMessage!==''" class="al-nobold">{{moreLessTextDispaly}}</a>
            </ng-template>
        </div>
    </div>
  `,
    host: {
        '(document:click)': 'outsideClick($event)'
    }
})
export class AlTipsAlertComponent {

    // Set text for tip to be displayed
    @Input() displayText: string;

    // Link for tip to be displayed.
    @Input() linkText: string;

    // Contextoverlay text for tips and alert
    @Input() tipMessage: string;

    // tip/action label value, default is Tip
    @Input() tipText: string = 'Tip';

    // set showhide popup dialog
    showHide: boolean;

    // Display More/Less feature, default is false
    @Input() moreLess: boolean = false;

    // More text value, default is More
    @Input() moreText: string = 'More';

    // Less text value, default is Less
    @Input() lessText: string = 'Less';

    // More or Less text value, default is More
    moreLessTextDispaly: string = this.moreText;

    // Tip/Badge type action or tip
    @Input() tipType: string = 'tip';

    // Tip/Badge size
    @Input() tipSize: string = 'large';

    // Tip/Badge title
    @Input() badgeTitle: string = '';

    /**
     * @constructs
     * Seting constructor method and required param
     *
     * @param _element
     *
     */
    constructor(private _element: ElementRef) {
        this.showHide = false;
    }

    /**
     * toggle tipsalerts popup dialog based on action
     * toggle to show More text or Less text based on click
     * @method toggleTipsAlerts
     *
     */
    /* istanbul ignore next */
    toggleTipsAlerts() {
        if (!this.moreLess) {
            this.showHide = !this.showHide;
        } else {
            if (this.moreLessTextDispaly === this.moreText) {
                this.moreLessTextDispaly = this.lessText;
            } else {
                this.moreLessTextDispaly = this.moreText;
            }
        }
    }

    /**
     * hide tipsalerts popup dialog, if clicked outside of popup
     *
     * @method outsideClick
     * @param event
     *
     */
    outsideClick(event) {
        /* istanbul ignore if */
        if (!this._element.nativeElement.contains(event.target) && this.showHide !== false) {
            /* istanbul ignore next */
            this.toggleTipsAlerts();
        }
    }
}
